import script from "./AppRadioCardButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppRadioCardButtons.vue?vue&type=script&lang=ts&setup=true"

import "./AppRadioCardButtons.vue?vue&type=style&index=0&id=3d1ad79b&lang=scss"

const __exports__ = script;

export default __exports__